module.exports = __webpack_public_path__ + "img/start.23df3da6.svg";